module.exports = __webpack_public_path__ + "static/media/room-2.052c7681.jpeg";